import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityTiposDocumentoState,
  entityTiposDocumentoAdapter
} from './entity-tipos-documento.state';

const { selectEntities, selectAll } =
  entityTiposDocumentoAdapter.getSelectors();

export const getError = (state: EntityTiposDocumentoState): any => state.error;

export const getIsLoading = (state: EntityTiposDocumentoState): boolean =>
  state.isLoading;

export const selectTiposDocumentoState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tiposDocumento
);

export const selectAllTiposDocumento = createSelector(
  selectTiposDocumentoState,
  selectAll
);
export const selectEntitiesTiposDocumento = createSelector(
  selectTiposDocumentoState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTiposDocumentoError = createSelector(
  selectTiposDocumentoState,
  getError
);

// MemoizedSelector<object,any>
export const selectTiposDocumentoIsLoading = createSelector(
  selectTiposDocumentoState,
  getIsLoading
);
